import { useSelector } from "react-redux";
import DataTable, { Column } from "../../components/DataTable";
import { AppDispatch, RootState } from "../../store";
import { Student } from "../../types/studentType";
import { useEffect, useRef } from "react";
import { getStudents } from "../../features/student/StudentSlice";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function StudentsInTheGroup() {
  const dispatch = useDispatch<AppDispatch>();

  const { students, isLoading, pagination, searchFilters } = useSelector(
    (state: RootState) => state.student,
  );

  const { groupId } = useParams();

  const branchCode = useBranchCode();

  const firstLoad = useRef(true);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      dispatch(
        getStudents({
          branchCode,
          page: pagination.currentPage,
          size: pagination.pageSize,
          studentName: searchFilters.studentName || "",
          groupId,
        }),
      );
      return;
    }
  }, [dispatch]);

  const tableData: Student[] = students.map((student) => ({
    ...student,
    id: student.admissionNumber,
  }));

  const columns: Column<Student>[] = [
    {
      label: "SL NO.",
      accessor: "admissionNumber",
    },
    {
      label: "Profile",
      accessor: "profile",
      render: (item) => (
        <div>
          {!item?.photoUrl ? (
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-600 text-white font-semibold">
              {item.fullName.charAt(0).toUpperCase()}
            </div>
          ) : (
            <img
              src={item?.photoUrl}
              alt=""
              className="flex items-center justify-center object-cover w-10 h-10 rounded-full"
            />
          )}
        </div>
      ),
    },
    {
      label: "Student Name",
      accessor: "fullName",
      searchable: true,
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item.fullName}
        </div>
      ),
    },
    {
      label: "Class",
      accessor: "classSection",
      render: (item) => <span>{item.classSection ?? "---"}</span>,
    },
    {
      label: "Academic Cycle",
      accessor: "academicCycle",
      render: (item) => (
        <span
          className={`px-2 py-1 text-xs font-medium rounded-[4px] bg-primary-50 text-primary-600`}
        >
          {item.academicCycle}
        </span>
      ),
    },
  ];

  return (
    <div className="bg-white px-6 py-5 rounded-lg flex flex-col gap-7 w-full">
      <h3 className="text-xl text-neutral-400 font-semibold">Added Students</h3>
      <div className="max-h-[500px] overflow-y-auto flex flex-col gap-5 custom-scrollbar">
        <DataTable columns={columns} data={tableData} isLoading={isLoading} />
      </div>
    </div>
  );
}
